module.exports = __webpack_public_path__ + "img/computer-top.be363580.svg";